import { gql } from '@apollo/client';
import type { UUID } from '@cobliteam/common-types';
import type { IdentificationTokenV2 } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class IdentifierTokensGraphQLRequester {
  public getIdentificationTokens = (
    input?: Partial<{
      driverIds?: string[];
      ids?: string[];
      isLinkedToDriver?: boolean;
    }>
  ): Promise<IdentificationTokenV2[]> =>
    graphQLRequester
      .query<{ tokensV2: IdentificationTokenV2[] }>({
        query: gql`
          query TokensV2($input: IdentificationTokenFilters) {
            tokensV2(input: $input) {
              id
              alias
              type
              driverId
              isExternal
              origin
              status
              tokenId
              cobliId
              lastUsage{
                timestamp
                location {
                  lat
                  lng
                }
                vehicle {
                  id
                  licensePlate
                  groups {
                    id
                  }
                }
              }
            }
          }`,
        variables: { input: input },
      })
      .then((result) => result.tokensV2);

  public associateIdentificationTokenToDriver = (driverId: UUID, tokenId: string): Promise<any> =>
    graphQLRequester
      .mutate<any>({
        mutation: gql`
              mutation AssociateTokenToDriver($id: String!, $driverId: String!) {
                associateTokenToDriver(id: $id, driverId: $driverId) {
                  id
                }
              }
            `,
        variables: {
          id: tokenId,
          driverId: driverId,
        },
      })
      .then((result) => {
        if (result.errors?.length) {
          throw result.errors[0];
        }
        return result;
      });

  public disassociateIdentificationTokenFromDriver = (tokenId: string): Promise<any> =>
    graphQLRequester
      .mutate<any>({
        mutation: gql`
          mutation DisassociateTokenFromDriver($id: String!){
            disassociateTokenFromDriver(id: $id)
          }
        `,
        variables: {
          id: tokenId,
        },
      })
      .then((result) => {
        if (result.errors?.length) {
          throw result.errors[0];
        }
        return result;
      });

  public deleteIdentificationToken = (tokenId: string): Promise<any> =>
    graphQLRequester
      .mutate<any>({
        mutation: gql`
          mutation DeleteToken($id: String!){
            deleteToken(id: $id)
          }
        `,
        variables: {
          id: tokenId,
        },
      })
      .then((result) => {
        if (result.errors?.length) {
          throw result.errors[0];
        }
        return result;
      });
}

export default IdentifierTokensGraphQLRequester;
